import { IonCard, IonCardContent, IonCardTitle } from '@ionic/react';

import { Button, ButtonProps } from '@/components/Button';

import { mergeClassNames } from '@/utils/mergeClassNames';

import styles from './BottomBar.module.css';

import { IconRotate } from '../Icon/types';

interface BottomBarButtonProps extends Omit<ButtonProps, 'size' | 'variant' | 'disabled' | 'leadingIcon'> {
  label: string;
  isDisabled?: boolean;
}

export interface BottomBarProps {
  title: string;
  description: string;
  prevButton?: BottomBarButtonProps;
  nextButton?: BottomBarButtonProps;
}

export const BottomBar = ({ title, description, prevButton, nextButton }: BottomBarProps) => {
  return (
    <IonCard className={styles.card}>
      <div className={styles.content}>
        <Button
          disabled={prevButton?.isDisabled}
          leadingIcon='chevron'
          leadingIconDirection={IconRotate.West}
          size='medium'
          variant='secondary'
          {...prevButton}
          className={mergeClassNames(!prevButton && styles.hidden, prevButton?.className)}>
          {prevButton?.label}
        </Button>

        <IonCardContent className={styles.cardContent}>
          <IonCardTitle className={styles.title}>{title}</IonCardTitle>
          <p className={styles.body}>{description}</p>
        </IonCardContent>

        <Button
          disabled={nextButton?.isDisabled}
          size='medium'
          trailingIcon='chevron'
          trailingIconDirection={IconRotate.East}
          {...nextButton}
          className={mergeClassNames(!nextButton && styles.hidden, nextButton?.className)}>
          {nextButton?.label}
        </Button>
      </div>
    </IonCard>
  );
};
